<!-- <a class="ad-container" (click)="viewportService?.type === 'desktop' ? onGotoAdDetail($event, ad) : ''"> -->
<a class="ad-container cursor-pointer" (click)="onGotoAdDetail($event, ad)">
	<!-- Paid -->
	<div class="paid" *ngIf="ad.vipPlus === '1' || ad.vip === '1'">
		<div class="stripe" [ngClass]="{ vipPlus: ad.vipPlus === '1', vip: ad.vip === '1' }"></div>
		<div
			[attr.dir]="ad.vipPlus === '1' ? 'ltr' : null"
			class="label"
			[ngClass]="{
				vipPlus: ad.vipPlus === '1',
				vip: ad.vip === '1'
			}"
		>
			{{ ad.vipPlus === '1' ? localeService.translations['n729'] : localeService.translations['ads']['ad']['n118'] }}
		</div>
	</div>

	<!-- Sold -->
	<div class="sold" *ngIf="ad.sold === '1'">
		<span class="label">
			{{ localeService.translations['ads']['ad']['n111'] }}
		</span>
	</div>

	<app-photo-layout [ad]="ad" [user]="user"></app-photo-layout>

	<!-- Contents -->
	<div class="contents">
		<div class="details">
			<div class="row mx-0 justify-content-between">
				<div class="col-auto px-0">
					<span class="price">&#36; {{ ad.price }}</span>
				</div>
				<div
					class="col-auto px-0 detail justify-content-center"
					[ngClass]="[ad['vipPlus'] === '1' ? (ad['vipViews'] | vipViewsColor) : (ad['views'] | vipViewsColor)]"
				>
					<div class="icon-wrapper ms-16px">
						<mat-icon>remove_red_eye</mat-icon>
						<span class="ms-2px">{{ ad['vipPlus'] === '1' ? ad['vipViews'] : ad['views'] }}</span>
						<ng-container *ngIf="ad?.['vipViews'] >= 10000 && ad?.['vipViews'] <= 19999">
							<img src="assets/images/vip/eye-emoji.png" class="emoji-img" />
						</ng-container>
						<ng-container *ngIf="ad?.['vipViews'] > 19999">
							<img src="assets/images/vip/fire-emoji.png" class="emoji-img" />
						</ng-container>
					</div>
				</div>
			</div>

			<h2 class="title mb-0">{{ ad.title }}</h2>

			<div class="row mx-0" *ngIf="ad['subCatID'] === '291'">
				<div class="col-auto px-0" *ngFor="let property of itemProperties">
					<div class="d-inline-block">
						<mat-icon class="fg-grey property-icons fs-16px">{{ property?.icon }}</mat-icon>
					</div>
					<span
						class="fg-grey ms-2px fs-11px align-top me-3"
						[ngClass]="{ 'me-3': localeService.lang === 'en', 'ms-3': localeService.lang !== 'en' }"
					>
						{{ property?.['descriptionItem'] }}
					</span>
				</div>
			</div>

			<div class="row mx-0" *ngIf="ad['subCatID'] !== '291'">
				<div class="col-auto px-0">
					<div class="d-inline-block">
						<mat-icon class="fg-grey property-icons fs-16px">place</mat-icon>
					</div>
					<span class="fg-grey fs-11px ms-2px align-top me-2">{{ ad.location }}</span>
				</div>
			</div>

			<p class="description mb-2">{{ ad.description }}</p>

			<a
				class="col-12 fg-accent text-end d-flex justify-content-start px-0"
				*ngIf="viewport.type !== 'desktop'"
				[href]="'/' + localeService.getLocale() + '/vip-plus?adLink=' + ad['adLink']"
			>
				<mat-icon class="fs-16px info mt-9px">info</mat-icon>
				<span class="vip-info fs-11px" dir="ltr">{{ localeService.translations['n702'] }}</span>
		</a>

			<mat-divider></mat-divider>
			<!-- Action buttons -->
			<div class="row mx-0">
				<div class="actions col px-0">
					<app-button
						class="call"
						customClass="w-100"
						[isDisabled]="ad.sold === '1'"
						[label]="ad.phone | maskPhone : toggleFullPhoneNumber"
						svgIcon="phone"
						[isStopPropagation]="true"
						(clicked)="onCall(ad)"
					></app-button>

					<div class="ad-item-chats-8px" *ngIf="ad.seller?.contactTypeWhatsapp === '1' && ad.sold === '0'">
						<!-- WhatsApp -->
						<app-button
							class="icon"
							svgIcon="whatsapp-2"
							[btnType]="buttonType.ICON"
							[isStopPropagation]="true"
							(clicked)="onCallPlatform(ad)"
						></app-button>
					</div>
				</div>
				<a
					class="col px-0 fg-accent text-end d-flex justify-content-end"
					*ngIf="viewport.type === 'desktop'"
					[href]="'/' + localeService.getLocale() + '/vip-plus?adLink=' + ad['adLink']"
				>
					<mat-icon class="fs-16px info mt-9px d-flex justify-content-center">info</mat-icon>
					<span class="vip-info fs-14px" dir="ltr">{{ localeService.translations['n702'] }}</span>
			</a>
			</div>
		</div>
	</div>
</a>
